import { render, staticRenderFns } from "./ImagePreviewCwmi.vue?vue&type=template&id=5bddcc6e&scoped=true&"
import script from "./ImagePreviewCwmi.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewCwmi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bddcc6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bddcc6e')) {
      api.createRecord('5bddcc6e', component.options)
    } else {
      api.reload('5bddcc6e', component.options)
    }
    module.hot.accept("./ImagePreviewCwmi.vue?vue&type=template&id=5bddcc6e&scoped=true&", function () {
      api.rerender('5bddcc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/IntelligentBookingResultMultiNew/components/ImagePreviewCwmi.vue"
export default component.exports